import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  regData: {
    id: "",
    name: "",
    other_name: "",
    last_name: "",
    preferred_name: "",
    email: "",
    phone_code: "",
    phone: "",
    position: "",
    start_date: "",
    end_date: "",
    status: "",
    showInput: false,
    positions: [],
    role: "",
    title: "",
  },
};

const directorsRegFormSlice = createSlice({
  name: "directorsRegForm",
  initialState,
  reducers: {
    setRegData: (state, action) => {
      state.regData = { ...state.regData, ...action.payload };
    },

    resetRegData: (state, action) => {
      const { entityId } = state;
      return {
        ...initialState,
        entityId,
        ...action.payload,
      };
    },

    handleAddNewPosition: (state) => {
      state.regData.positions = [
        ...state.regData.positions,
        {
          end_date: null,
          position: null,
          start_date: null,
          status: null,
        },
      ];
    },
    handleRemovePosition: (state, action) => {
      const filterPostion = state.regData.positions.filter(
        (data, index) => index !== action.payload,
      );
      state.regData.positions = filterPostion;
    },
    handleEditPositionField: (state, action) => {
      state.regData.positions[action.payload.index][action.payload.field] =
        action.payload.value;
    },
    handleSetPositionsData: (state, action) => {
      state.regData.positions = action.payload;
    },
  },
});

export const {
  setRegData,
  resetRegData,
  showPositionInput,
  hidePositionInput,
  handleAddNewPosition,
  handleRemovePosition,
  handleEditPositionField,
  handleSetPositionsData,
} = directorsRegFormSlice.actions;

export default directorsRegFormSlice.reducer;
